import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    autoDismiss: Boolean,
    delay: { type: Number, default: 5000 }
  }

  connect() {
    if (!this.autoDismissValue) return

    this.timeout = window.setTimeout(() => this.dismiss(), this.delayValue)
  }

  disconnect() {
    window.clearTimeout(this.timeout)
  }

  dismiss() {
    const region = this.element.parentElement

    this.element.remove()
    if (region && !region.querySelector(".flash-message")) region.remove()
  }
}
